import { state, props } from 'cerebral/tags'
import { set } from 'cerebral/operators'
import filterCompute from '../computed/filterCompute'

const onSelectOption = hooks => {
  return [
    ({ resolve, state, props }) => {
      const filteredOptions = resolve.value(filterCompute(props.namespace))
      const option = filteredOptions[props.index]
      state.splice(`selectr.${props.namespace}.options`, option.index, 1)
      state.push(`selectr.${props.namespace}.selected`, { label: option.label })
      return {
        value: option.label
      }
    },
    set(state`selectr.${props`namespace`}.focusedOption`, null),
    set(state`selectr.${props`namespace`}.input.value`, ''),
    set(state`selectr.${props`namespace`}.focusInput`, true),
    set(state`selectr.${props`namespace`}.optionsClosed`, true),
    set(props`payload`, state`selectr.${props`namespace`}.payload`),

    ...hooks.onSelectOption
  ]
}

export default onSelectOption
